import * as React from 'react'

import Svg, { ClipPath, Defs, G, Path } from 'react-native-svg'

import { IconProps } from '../icons'

const UnAssignedOutlined = ({
  size = 24,
  color = '#000',
  ...props
}: IconProps) => (
  <Svg width={`${size}px`} height={`${size}px`} fill="none" {...props}>
    <G clipPath="url(#a)" fillRule="evenodd" clipRule="evenodd" fill="#EE6654">
      <Path d="M9.23 7.89a2.83 2.83 0 1 1 5.66 0 2.83 2.83 0 0 1-5.66 0Zm2.83-4.43a4.43 4.43 0 0 0-2.676 7.96c-3.609.777-6.374 3.837-6.374 7.54v.78a.8.8 0 0 0 1.6 0v-.78c0-3.322 2.915-6.13 6.57-6.13h1.66c1.365 0 2.636.395 3.678 1.063a.8.8 0 1 0 .864-1.347 8.32 8.32 0 0 0-2.668-1.11A4.43 4.43 0 0 0 12.06 3.46Z" />
      <Path d="M20.716 16.446a.8.8 0 1 0-1.132-1.132L17.92 16.98l-1.664-1.665a.8.8 0 0 0-1.132 1.132l1.665 1.664-1.665 1.664a.8.8 0 1 0 1.132 1.132l1.664-1.665 1.664 1.665a.8.8 0 1 0 1.132-1.132L19.05 18.11l1.665-1.664Z" />
    </G>
    <Defs>
      <ClipPath id="a">
        <Path fill="#fff" d="M0 0h24v24H0z" />
      </ClipPath>
    </Defs>
  </Svg>
)

export default UnAssignedOutlined
